import { View } from '../components/scheduling/ViewMenu';
import { PanelType } from '../components/routes/DetailsPanel/PanelType';

// Pure resolution of "what does the scheduling URL mean for the panels".
// Extracted from the UI store getters (src/store/mst/UI.ts) so the rules are
// testable without standing up the whole MST tree — mirrors the
// chooseTabForDate extraction.

// Parse the raw `view` query-param into a known View, or undefined when the
// param is missing or unrecognised. The store trusts the URL only after this
// guard.
export const viewFromParam = (raw: string | null | undefined): View | undefined => {
  const view = (raw as View) || undefined;
  return view && Object.values(View).includes(view) ? view : undefined;
};

// The left list panel (route list / order list) is shown on the two list views.
export const leftPanelOpenForView = (view: View | undefined): boolean => view === View.UNSCHEDULED_LIST || view === View.SCHEDULED_LIST;

// The bottom panel (Gantt timeline / unscheduled table) is shown on those views.
export const bottomPanelOpenForView = (view: View | undefined): boolean => view === View.TIMELINE || view === View.UNSCHEDULED_TABLE;

// Full-bleed map: no list or bottom drawer. An unset view is not map-only —
// date toggles clear ?view= before the tab lands, and that gap still uses
// destination chrome. View.MAP and any future view with neither panel are.
export const isMapOnlyChromeView = (
  view: View | null | undefined,
): view is View => {
  if (view == null) {
    return false;
  }
  return !leftPanelOpenForView(view) && !bottomPanelOpenForView(view);
};

export interface DetailsSelection {
  hasSelectedVisit: boolean;
  hasSelectedRoute: boolean;
  hasSelectedRouteEvent: boolean;
}

// Which details panel a deep link / selection opens in the right drawer. An
// order opens Order Details; a route or a stop (route event) opens Route
// Details; nothing selected → no panel.
export const detailsPanelForSelection = ({
  hasSelectedVisit,
  hasSelectedRoute,
  hasSelectedRouteEvent,
}: DetailsSelection): PanelType | undefined => {
  if (hasSelectedVisit) return PanelType.ORDER_DETAILS;
  if (hasSelectedRoute || hasSelectedRouteEvent) return PanelType.ROUTE_DETAILS;
  return undefined;
};
